import { render } from "./history-staff.vue?vue&type=template&id=2e30aa24&scoped=true&ts=true"
import script from "./history-staff.vue?vue&type=script&lang=ts"
export * from "./history-staff.vue?vue&type=script&lang=ts"

import "./history-staff.vue?vue&type=style&index=0&id=2e30aa24&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e30aa24"]])

export default __exports__